<template>
  <transition name="slideTransition">
    <div v-if="!dismissed" :class="wrapperClass">
      <page-banner
        v-bind="$attrs"
        class="tip top-actions"
        dense
        :icon="!withoutIcon ? 'mdi-lightbulb-on-outline' : undefined"
        :inline-actions="inlineActions"
        :class="{'q-mx-auto': center}"
      >
        <slot />

        <template #action>
          <slot name="action" />
          <q-btn
            flat
            round
            dense
            size="12px"
            icon="mdi-close"
            @click="dismissTip"
          >
            <q-tooltip>Dismiss Tip</q-tooltip>
          </q-btn>
        </template>
      </page-banner>
    </div>
  </transition>
</template>

<script>
import tipMixin from './mixin'

export default {
  mixins: [tipMixin],
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      required: true
    },
    center: {
      type: Boolean,
      default: false
    },
    inlineActions: {
      type: Boolean,
      default: true
    },
    withoutIcon: {
      type: Boolean,
      default: false
    },
    wrapperClass: {
      type: [String, Object]
    }
  },
  data () {
    return {
      dismissed: true
    }
  },
  computed: {
    hasDismissedTip () {
      return this.baseHasDismissedTip(this.name)
    },
    hasActionSlot () {
      return !!this.$slots.action
    }
  },
  watch: {
    'hasDismissedTip' () {
      this.dismissed = true
    }
  },
  methods: {
    dismissTip () {
      this.dismissed = true
      this.baseDismissTip(this.name)
    }
  },
  created () {
    this.dismissed = this.hasDismissedTip
  }
}
</script>
